var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 2.6665H20.0002C18.2321 2.6665 16.5364 3.36888 15.2861 4.61913C14.0359 5.86937 13.3335 7.56506 13.3335 9.33317V13.3332H9.3335V18.6665H13.3335V29.3332H18.6668V18.6665H22.6668L24.0002 13.3332H18.6668V9.33317C18.6668 8.97955 18.8073 8.64041 19.0574 8.39036C19.3074 8.14031 19.6465 7.99984 20.0002 7.99984H24.0002V2.6665Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.79b88a76bafb7ed81dec141c1154ff3f.svg";
export { ForwardRef as ReactComponent };